import { TripType } from '@fcom/core/interfaces/triptype.interface';
import { GlobalBookingTravelClass } from '@fcom/core';

import { MarketingOffer, MarketingOfferPrices } from '../../interfaces/marketing-offer.interface';

export type CountryMinOffer = {
  destinationCode: string;
  priceOffer: MarketingOfferPrices;
};

export const computeCountryMinOfferMap = (
  countryDestinationsMap: Record<string, string[]>,
  offers: MarketingOffer[],
  countryTripTypes: Record<string, TripType>
): Record<string, CountryMinOffer> => {
  const entries = Object.entries(countryDestinationsMap);
  if (entries.length === 0 || offers.length === 0) {
    return {};
  }

  const offersByDestination = new Map<string, MarketingOffer>();
  for (const offer of offers) {
    if (offer?.destination) {
      offersByDestination.set(offer.destination, offer);
    }
  }

  const result: Record<string, CountryMinOffer> = {};

  for (const [countryCode, destinationCodes] of entries) {
    const targetTripType = countryTripTypes[countryCode] ?? TripType.RETURN;
    let bestAmount = Infinity;
    let best: CountryMinOffer | null = null;

    for (const destinationCode of destinationCodes) {
      const offer = offersByDestination.get(destinationCode);
      if (!offer?.prices?.length) {
        continue;
      }

      const priceOffer = offer.prices.find(
        (p) => p.travelClass === GlobalBookingTravelClass.ECONOMY && p.price?.tripType === targetTripType
      );

      if (!priceOffer?.price?.amount) {
        continue;
      }

      const amount = Number(priceOffer.price.amount);
      if (!Number.isNaN(amount) && amount < bestAmount) {
        bestAmount = amount;
        best = { destinationCode, priceOffer };
      }
    }

    if (best) {
      result[countryCode] = best;
    }
  }

  return result;
};
